import { render } from "./CorporateMemberships.vue?vue&type=template&id=6be041ce&scoped=true"
const script = {}

import "./CorporateMemberships.vue?vue&type=style&index=0&id=6be041ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be041ce"]])

export default __exports__